import React from 'react';
import { LayoutDashboard, Users, Megaphone, Star, Globe, User, Search, ChevronDown, Filter, Copy, Link2 } from 'lucide-react';
export const Sidebar = ({
  active
}: {
  active: string;
}) => {
  const menu = [{
    name: 'Dashboard',
    icon: LayoutDashboard
  }, {
    name: 'Roster Database',
    icon: Users
  }, {
    name: 'Casting Calls',
    icon: Megaphone
  }, {
    name: 'Talent Agencies',
    icon: Star
  }, {
    name: 'The Creator Network',
    icon: Globe,
    badge: 'New'
  }];
  return <div className="w-48 border-r border-gray-100 bg-white flex flex-col shrink-0 hidden md:flex" data-id="element-1125">
      <div className="p-4" data-id="element-1126">
        <div className="text-xl font-extrabold text-zano-pink lowercase tracking-tight" data-id="element-1127">
          zano
        </div>
      </div>
      <div className="px-3 py-2 text-[10px] font-semibold text-gray-400 uppercase tracking-wider" data-id="element-1128">
        Main Menu
      </div>
      <div className="space-y-0.5 px-2" data-id="element-1129">
        {menu.map(m => <div key={m.name} className={`flex items-center gap-2 px-2 py-1.5 rounded-md text-xs font-medium cursor-pointer ${active === m.name ? 'bg-pink-50 text-zano-pink' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1130">
            <m.icon size={14} className={active === m.name ? 'text-zano-pink' : 'text-gray-400'} data-id="element-1131" />
            <span className="truncate" data-id="element-1132">{m.name}</span>
            {m.badge && <span className="ml-auto text-[8px] bg-pink-100 text-zano-pink px-1.5 py-0.5 rounded-sm" data-id="element-1133">
                {m.badge}
              </span>}
          </div>)}
      </div>
    </div>;
};
export const Topbar = ({
  title,
  subtitle
}: {
  title: string;
  subtitle?: string;
}) => <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-white" data-id="element-1134">
    <div data-id="element-1135">
      <h1 className="text-lg font-bold text-gray-900" data-id="element-1136">{title}</h1>
      {subtitle && <p className="text-xs text-gray-500" data-id="element-1137">{subtitle}</p>}
    </div>
    <div className="flex items-center gap-2" data-id="element-1138">
      <div className="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center text-gray-500" data-id="element-1139">
        <User size={12} data-id="element-1140" />
      </div>
      <span className="text-xs font-medium text-gray-700 hidden sm:inline" data-id="element-1141">
        Sapir Tori
      </span>
    </div>
  </div>;
export const MockupLayout = ({
  active,
  title,
  subtitle,
  children
}: any) => <div className="bg-gray-50 rounded-xl border border-gray-200 shadow-sm overflow-hidden flex h-[400px] text-left w-full" data-id="element-1142">
    <Sidebar active={active} data-id="element-1143" />
    <div className="flex-1 flex flex-col overflow-hidden min-w-0" data-id="element-1144">
      <Topbar title={title} subtitle={subtitle} data-id="element-1145" />
      <div className="flex-1 overflow-auto p-4" data-id="element-1146">{children}</div>
    </div>
  </div>;
export const TTIco = () => <span className="text-[10px] font-bold" data-id="element-1147">TT</span>;
export const IGIco = () => <span className="text-[10px] font-bold text-pink-500" data-id="element-1148">IG</span>;
export const YTIco = () => <span className="text-[10px] font-bold text-red-500" data-id="element-1149">YT</span>;
export const DirectoryMockup = () => {
  const agencies = [{
    name: 'United Talent Agency',
    short: 'UTA',
    inf: '895',
    tt: '2B',
    ig: '1B',
    yt: '0',
    email: 'CreatorsBrandPartnerships@unitedtalent.com'
  }, {
    name: 'Clicks Talent',
    short: 'CT',
    inf: '886',
    tt: '393M',
    ig: '285M',
    yt: '917M',
    email: 'ab@clickstalent.com',
    link: true
  }, {
    name: 'Viral Nation Inc',
    short: 'VN',
    inf: '442',
    tt: '759M',
    ig: '274M',
    yt: '286M',
    email: 'ena@viralnation.com',
    link: true
  }, {
    name: 'Viral Hub Marketing',
    short: 'VH',
    inf: '190',
    tt: '38M',
    ig: '14M',
    yt: '8M',
    email: 'daniel@viralhubmarketing.com',
    link: true
  }, {
    name: 'Connect Management',
    short: 'CM',
    inf: '150',
    tt: '232M',
    ig: '57M',
    yt: '20M',
    email: 'oliver@connectmgt.com',
    link: true
  }];
  return <MockupLayout active="Talent Agencies" title="Talent Agencies" data-id="element-1150">
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1151">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1152">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1153">
            <tr data-id="element-1154">
              <th className="px-3 py-2 font-medium" data-id="element-1155">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1156">Influencers ↑</th>
              <th className="px-3 py-2 font-medium" data-id="element-1157">
                <TTIco data-id="element-1158" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1159">
                <IGIco data-id="element-1160" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1161">
                <YTIco data-id="element-1162" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1163">Website</th>
              <th className="px-3 py-2 font-medium" data-id="element-1164">Email</th>
              <th className="px-3 py-2 font-medium" data-id="element-1165"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1166">
            {agencies.map((a, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1167">
                <td className="px-3 py-2 flex items-center gap-2" data-id="element-1168">
                  <div className="w-6 h-6 bg-gray-900 text-white rounded-full flex items-center justify-center text-[8px] font-bold shrink-0" data-id="element-1169">
                    {a.short}
                  </div>
                  <span className="font-medium text-gray-900" data-id="element-1170">{a.name}</span>
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1171">{a.inf}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1172">{a.tt}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1173">{a.ig}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1174">{a.yt}</td>
                <td className="px-3 py-2 text-gray-400" data-id="element-1175">
                  {a.link && <Link2 size={12} data-id="element-1176" />}
                </td>
                <td className="px-3 py-2 text-gray-500 truncate max-w-[120px]" data-id="element-1177">
                  {a.email}
                </td>
                <td className="px-3 py-2 text-right" data-id="element-1178">
                  <div className="flex items-center justify-end gap-2" data-id="element-1179">
                    <Copy size={12} className="text-gray-400" data-id="element-1180" />
                    <button className="border border-gray-200 text-gray-700 rounded px-2 py-1 text-[10px] font-medium bg-white" data-id="element-1181">
                      View Roster
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const CastingCallMockup = () => {
  const calls = [{
    name: 'Temu US campaign short form',
    budget: '$10,000 - $120,000',
    cat: '-',
    type: 'Paid Promo',
    plats: ['TT', 'IG'],
    posted: 'Braco US',
    date: 'Jun 26'
  }, {
    name: 'Kopouch World Cup Activation',
    budget: '$400 - $600',
    cat: '-',
    type: 'Paid Promo',
    plats: ['IG'],
    posted: 'Clicks Talent',
    date: 'Jun 4'
  }, {
    name: 'Leesa Summer',
    budget: '$42 - $6,000',
    cat: 'Beauty, Book Reviews...',
    type: 'Paid Promo',
    plats: ['YT'],
    posted: 'The Outloud Group',
    date: 'May 22'
  }, {
    name: 'DJI',
    budget: '-',
    cat: '-',
    type: 'Paid Promo',
    plats: ['IG'],
    posted: 'Clicks Talent',
    date: 'May 14'
  }];
  return <MockupLayout active="Casting Calls" title="Casting Calls" subtitle="24 Casting Calls" data-id="element-1182">
      <div className="flex items-center justify-between mb-3" data-id="element-1183">
        <div className="flex items-center gap-3" data-id="element-1184">
          <button className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs font-medium text-gray-700" data-id="element-1185">
            <Filter size={12} data-id="element-1186" /> All filters
          </button>
          <button className="text-xs text-gray-500 underline" data-id="element-1187">Clear all</button>
        </div>
        <button className="bg-pink-100 text-pink-600 px-3 py-1.5 rounded text-xs font-medium" data-id="element-1188">
          + New Casting Call
        </button>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1189">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1190">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1191">
            <tr data-id="element-1192">
              <th className="px-3 py-2 font-medium" data-id="element-1193">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1194">Budget</th>
              <th className="px-3 py-2 font-medium" data-id="element-1195">Category</th>
              <th className="px-3 py-2 font-medium" data-id="element-1196">Type of Collaboration</th>
              <th className="px-3 py-2 font-medium" data-id="element-1197">Platforms</th>
              <th className="px-3 py-2 font-medium" data-id="element-1198">Posted By</th>
              <th className="px-3 py-2 font-medium" data-id="element-1199">Date Posted</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1200">
            {calls.map((c, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1201">
                <td className="px-3 py-2 font-medium text-gray-900 truncate max-w-[150px]" data-id="element-1202">
                  {c.name}
                </td>
                <td className="px-3 py-2 text-green-600 font-medium" data-id="element-1203">
                  {c.budget}
                </td>
                <td className="px-3 py-2 text-gray-500 truncate max-w-[100px]" data-id="element-1204">
                  {c.cat}
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1205">{c.type}</td>
                <td className="px-3 py-2 flex gap-1" data-id="element-1206">
                  {c.plats.includes('TT') && <TTIco data-id="element-1207" />}
                  {c.plats.includes('IG') && <IGIco data-id="element-1208" />}
                  {c.plats.includes('YT') && <YTIco data-id="element-1209" />}
                </td>
                <td className="px-3 py-2 text-gray-700 flex items-center gap-1" data-id="element-1210">
                  <div className="w-4 h-4 bg-gray-200 rounded-full shrink-0" data-id="element-1211"></div>
                  <span className="truncate max-w-[100px]" data-id="element-1212">{c.posted}</span>
                </td>
                <td className="px-3 py-2 text-gray-500" data-id="element-1213">{c.date}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const SubmissionsMockup = CastingCallMockup;
export const RosterDatabaseMockup = () => {
  const creators = [{
    name: 'Dr. Aamir Hussain',
    cat: 'Academia',
    country: 'United Kingdom',
    tt: '-',
    ig: '39.3K',
    yt: '2.9K',
    agency: 'KAW Management Group',
    excl: 'Non-Exclusive',
    email: 'connect@kawmanagementgroup.com'
  }, {
    name: 'Ganyah Goldstein',
    cat: 'Academia',
    country: 'United Kingdom',
    tt: '82.9K',
    ig: '38.1K',
    yt: '-',
    agency: 'Viral Hub Marketing',
    excl: 'Non-Exclusive',
    email: 'daniel@viralhubmarketing.com'
  }, {
    name: 'Julius Doyle',
    cat: 'Academia',
    country: 'United States',
    tt: '-',
    ig: '449.8K',
    yt: '-',
    agency: 'Clicks Talent',
    excl: 'Non-Exclusive',
    email: 'amaany@clickstalentagency.com'
  }, {
    name: 'Stephanie & Loreal',
    cat: 'Academia',
    country: 'United States',
    tt: '169.8K',
    ig: '456.8K',
    yt: '-',
    agency: 'Boost Society',
    excl: 'Exclusive',
    email: 'josh@boost-society.com'
  }];
  return <MockupLayout active="Roster Database" title="Roster Database" data-id="element-1214">
      <div className="flex items-center gap-2 mb-3 overflow-x-auto pb-1" data-id="element-1215">
        <div className="relative flex-1 min-w-[120px]" data-id="element-1216">
          <Search size={12} className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1217" />
          <input type="text" placeholder="Search" className="w-full pl-6 pr-2 py-1 border border-gray-200 rounded text-xs outline-none" data-id="element-1218" />
        </div>
        {['Platforms', 'Categories', 'Countries'].map(f => <button key={f} className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs text-gray-700 whitespace-nowrap" data-id="element-1219">
            {f} <ChevronDown size={10} data-id="element-1220" />
          </button>)}
        <button className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs font-medium text-gray-700 whitespace-nowrap" data-id="element-1221">
          <Filter size={12} data-id="element-1222" /> All filters
        </button>
        <button className="text-xs text-gray-500 underline whitespace-nowrap" data-id="element-1223">
          Clear all
        </button>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1224">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1225">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1226">
            <tr data-id="element-1227">
              <th className="px-3 py-2 font-medium" data-id="element-1228">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1229">Category ↓</th>
              <th className="px-3 py-2 font-medium" data-id="element-1230">Country</th>
              <th className="px-3 py-2 font-medium" data-id="element-1231">
                <TTIco data-id="element-1232" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1233">
                <IGIco data-id="element-1234" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1235">
                <YTIco data-id="element-1236" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1237">Agency Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1238">Exclusivity</th>
              <th className="px-3 py-2 font-medium" data-id="element-1239">Contact Email</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1240">
            {creators.map((c, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1241">
                <td className="px-3 py-2 flex items-center gap-2" data-id="element-1242">
                  <div className="w-5 h-5 bg-gray-200 rounded-full shrink-0" data-id="element-1243"></div>
                  <span className="font-medium text-gray-900 truncate max-w-[100px]" data-id="element-1244">
                    {c.name}
                  </span>
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1245">{c.cat}</td>
                <td className="px-3 py-2 text-gray-600 truncate max-w-[80px]" data-id="element-1246">
                  {c.country}
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1247">{c.tt}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1248">{c.ig}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1249">{c.yt}</td>
                <td className="px-3 py-2 text-gray-700 truncate max-w-[100px]" data-id="element-1250">
                  {c.agency}
                </td>
                <td className="px-3 py-2 text-gray-500" data-id="element-1251">{c.excl}</td>
                <td className="px-3 py-2 text-gray-500 flex items-center justify-between gap-2" data-id="element-1252">
                  <span className="truncate max-w-[120px]" data-id="element-1253">{c.email}</span>
                  <Copy size={10} className="text-gray-400 shrink-0" data-id="element-1254" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const InsightsMockup = () => {
  return <MockupLayout active="Dashboard" title="Dashboard" data-id="element-1255">
      <div className="space-y-4" data-id="element-1256">
        <div data-id="element-1257">
          <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-1258">
            Talent Agencies
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-1259">
            {[{
            title: 'TikTok Top Agencies',
            icon: <TTIco data-id="element-1260" />,
            data: [{
              n: 'United Talent Agency',
              v: '1,886,760,587'
            }, {
              n: 'Viral Nation Inc',
              v: '758,591,677'
            }]
          }, {
            title: 'Instagram Top Agencies',
            icon: <IGIco data-id="element-1261" />,
            data: [{
              n: 'United Talent Agency',
              v: '1,169,648,463'
            }, {
              n: 'Clicks Talent',
              v: '284,615,765'
            }]
          }, {
            title: 'YouTube Top Agencies',
            icon: <YTIco data-id="element-1262" />,
            data: [{
              n: 'Clicks Talent',
              v: '916,534,313'
            }, {
              n: 'Viral Nation Inc',
              v: '286,009,190'
            }]
          }].map(col => <div key={col.title} className="bg-white border border-gray-200 rounded-lg p-3" data-id="element-1263">
                <div className="flex items-center gap-1 text-xs font-semibold text-gray-900 mb-3" data-id="element-1264">
                  {col.icon} {col.title}
                </div>
                <div className="space-y-2" data-id="element-1265">
                  {col.data.map(d => <div key={d.n} className="flex justify-between items-center text-[10px]" data-id="element-1266">
                      <div className="flex items-center gap-1" data-id="element-1267">
                        <div className="w-3 h-3 bg-gray-900 rounded-full shrink-0" data-id="element-1268"></div>
                        <span className="text-gray-700 truncate max-w-[80px]" data-id="element-1269">
                          {d.n}
                        </span>
                      </div>
                      <span className="text-gray-500 font-medium" data-id="element-1270">{d.v}</span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>

        <div data-id="element-1271">
          <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-1272">
            Pricing
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-1273">
            {[{
            title: 'TikTok Pricing',
            icon: <TTIco data-id="element-1274" />,
            data: [{
              n: 'Video Post',
              v: '$7,746'
            }, {
              n: 'Link in Bio',
              v: '$5,378'
            }]
          }, {
            title: 'Instagram Pricing',
            icon: <IGIco data-id="element-1275" />,
            data: [{
              n: 'Photo',
              v: '$7,102'
            }, {
              n: 'Reels',
              v: '$8,722'
            }]
          }, {
            title: 'YouTube Pricing',
            icon: <YTIco data-id="element-1276" />,
            data: [{
              n: 'Integration',
              v: '$6,196'
            }, {
              n: 'Dedication',
              v: '$8,995'
            }]
          }].map(col => <div key={col.title} className="bg-white border border-gray-200 rounded-lg p-3" data-id="element-1277">
                <div className="flex items-center gap-1 text-xs font-semibold text-gray-900 mb-3" data-id="element-1278">
                  {col.icon} {col.title}
                </div>
                <div className="space-y-2" data-id="element-1279">
                  {col.data.map(d => <div key={d.n} className="flex justify-between items-center text-[10px]" data-id="element-1280">
                      <span className="text-gray-600" data-id="element-1281">{d.n}</span>
                      <span className="text-green-600 font-medium" data-id="element-1282">{d.v}</span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </MockupLayout>;
};
export const MediaKitLinkMockup = () => <MockupLayout active="Talent Agencies" title="Media Kits" data-id="element-1283">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1284">
      <div className="border-b border-gray-100 p-4 flex items-center gap-2 bg-gray-50/50" data-id="element-1285">
        <Link2 size={16} className="text-gray-500" data-id="element-1286" />
        <span className="font-semibold text-sm text-gray-800 flex-1" data-id="element-1287">
          zano.co/agency/uta
        </span>
        <span className="text-xs text-zano-pink font-medium" data-id="element-1288">Copy link</span>
      </div>
      <div className="px-4 pt-3 flex items-center gap-2" data-id="element-1289">
        <div className="flex-1 bg-gray-50 border border-gray-200 rounded-md px-2.5 py-1 text-xs text-gray-400 flex items-center gap-1" data-id="element-1290">
          <Search size={11} data-id="element-1291" /> Filter by followers, niche, location…
        </div>
      </div>
      <div className="p-4 grid grid-cols-2 gap-3" data-id="element-1292">
        {[1, 2].map(c => <div key={c} className="border border-gray-100 rounded-lg p-3" data-id="element-1293">
            <div className="w-10 h-10 bg-gray-200 rounded-full mb-2" data-id="element-1294"></div>
            <div className="flex items-center gap-1.5" data-id="element-1295">
              <p className="text-sm font-semibold text-gray-900" data-id="element-1296">
                Creator Name
              </p>
            </div>
            <p className="text-xs text-gray-500" data-id="element-1297">1.2M • 4.8% ENG</p>
          </div>)}
      </div>
    </div>
  </MockupLayout>;
export const MediaKitMockup = () => <MockupLayout active="Talent Agencies" title="Creator Profile" data-id="element-1298">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1299">
      <div className="bg-gray-50 border-b border-gray-200 p-4 flex items-center gap-3" data-id="element-1300">
        <div className="w-12 h-12 bg-gray-200 rounded-full" data-id="element-1301"></div>
        <div data-id="element-1302">
          <h4 className="font-bold text-gray-900" data-id="element-1303">Elena Rodriguez</h4>
          <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-1304">
            <Globe size={12} data-id="element-1305" /> LA • UTA
          </p>
        </div>
      </div>
      <div className="p-4 grid grid-cols-3 gap-3" data-id="element-1306">
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1307">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1308">Followers</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1309">1.2M</p>
        </div>
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1310">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1311">Avg views</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1312">340K</p>
        </div>
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1313">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1314">Eng.</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1315">4.8%</p>
        </div>
      </div>
    </div>
  </MockupLayout>;
export const RosterMockup = () => <MockupLayout active="Talent Agencies" title="Your Roster" data-id="element-1316">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1317">
      <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex justify-between items-center" data-id="element-1318">
        <span className="font-semibold text-sm text-gray-800" data-id="element-1319">Your Roster</span>
        <span className="text-xs text-zano-pink font-medium" data-id="element-1320">
          + Add creator
        </span>
      </div>
      <div className="p-4 grid grid-cols-2 gap-4" data-id="element-1321">
        <div className="border border-gray-100 rounded-lg p-3 bg-gray-50" data-id="element-1322">
          <p className="text-xs text-gray-500 mb-1" data-id="element-1323">Active roster</p>
          <p className="text-xl font-bold text-gray-900" data-id="element-1324">42</p>
        </div>
        <div className="border border-gray-100 rounded-lg p-3 bg-gray-50" data-id="element-1325">
          <p className="text-xs text-gray-500 mb-1" data-id="element-1326">Casting inbound</p>
          <p className="text-xl font-bold text-gray-900" data-id="element-1327">18</p>
        </div>
      </div>
    </div>
  </MockupLayout>;
export const PartnerRosterMockup = () => <MockupLayout active="Talent Agencies" title="Partner Agencies" data-id="element-1328">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1329">
      <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex items-center gap-2" data-id="element-1330">
        <span className="font-semibold text-sm text-gray-800" data-id="element-1331">
          My partner agencies
        </span>
      </div>
      <div className="px-4 pt-3 flex gap-1.5" data-id="element-1332">
        {['UTA', 'Viral Nation', 'Fixated'].map(a => <span key={a} className="text-[10px] text-zano-pink bg-zano-blush rounded-full px-2 py-0.5 font-medium" data-id="element-1333">
            {a}
          </span>)}
      </div>
      <div className="p-4 space-y-3" data-id="element-1334">
        {[1, 2].map(c => <div key={c} className="flex items-center justify-between p-3 border border-gray-100 rounded-lg" data-id="element-1335">
            <div className="flex items-center gap-3" data-id="element-1336">
              <div className="w-9 h-9 bg-gray-200 rounded-full" data-id="element-1337"></div>
              <div data-id="element-1338">
                <p className="text-sm font-semibold text-gray-900" data-id="element-1339">
                  Creator {c}
                </p>
                <p className="text-xs text-gray-500" data-id="element-1340">Agency • live roster</p>
              </div>
            </div>
            <span className="text-xs bg-green-50 text-green-700 border border-green-200 px-2 py-0.5 rounded-full" data-id="element-1341">
              Updated
            </span>
          </div>)}
      </div>
    </div>
  </MockupLayout>;